import { N14_03 } from "./N14_03";

export const N14_02 = {
  selectedValueColumn: "DrillKey",
  selectedTitle: "District",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "District",
        binding: {
          data: {
            columns: [
              {
                name: "District",
                columnName: "DistrictName",
                width: "400px",
                align: "left",
                sortable: true
              },
              {
                name: "Total Count",
                columnName: "TotalCount",
                width: "180px",
                align: "center",
                sortable: true
              },
            ],
            title: "DistrictName",
            endpoint: "SFE_N14.2",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "DrillKey", value: "" },
            ],
          },
          context: {
            point: {
              onClick: N14_03,
            },
          },
        },
      },
    },
  ],
};